import * as request from '@/utils/request'

export default {
  /**
   * getPublicationList
   * @description 刊例列表列表
   * @param {*} data
   * @returns
   */
  getPublicationList(data) {
    return request.post('/plc/list', data)
  }, /**
   * 刊例详情
   * @param id
   * @returns {Promise}
   */
  getPublicationInfo(id) {
    return request.post('/plc/get_info', { id: id })
  }, /**
   * 根据本期刊例ID获取其上期的刊例数据
   * @param currentId
   * @returns {Promise}
   */
  getPublicationLast(currentId) {
    return request.post('/plc/get_last', { id: currentId })
  },

  /**
   * 刊例调整说明的文章ID
   *
   * @returns {Promise}
   */
  orderPublication(ids) {
    return request.post('/plc/order', { ids: ids })
  }, /**
   * 刊例排序更新
   *
   * @returns {Promise}
   */
  getPublicationArticleID() {
    return request.post('/plc/get_article_id', {})
  }, /**
   * 获取刊例导出的数据
   * @param year
   * @param month
   * @returns {Promise}
   */
  getExportPublicationAllData(year, month) {
    return request.post('/plc/export_data', { year: year, month: month })
  },

  /**
   * 导出刊例
   * @param year
   * @param month
   * @returns {Promise}
   */
  exportPublicationAsExcel(year, month) {
    return request.postBlob('/plc/export', { year: year, month: month })
  }, /**
   * 请求golang服务-获取excel文件
   * @param data
   * @returns {Promise}
   */
  downloadPublicationExcelByData(data) {
    return request.postBlob('/tools_api/module/spreadSheets/create', data)
  }, /**
   * 修改刊例基本信息
   * @param data
   * @returns {Promise}
   */
  savePublicationInfo(data) {
    return request.post('/plc/store', data)
  }, /**
   * 新增
   * @param data
   * @returns {Promise}
   */
  addPublicationInfo(data) {
    return request.post('/plc/add', data)
  }, /**
   * 删除刊例
   * @param id
   * @returns {Promise}
   */
  deletePublicationInfo(id) {
    let data = { id: id }
    return request.post('/plc/delete', data)
  }, /**
   * 删除刊例明细
   * @param id
   * @returns {Promise}
   */
  deletePublicationItem(id) {
    let data = { id: id }
    return request.post('/plc_item/delete', data)
  },
  /**
   * 获取上月刊例
   * @param data
   * @returns {Promise}
   */
  getLastPublicationItem(data) {
    return request.post('/plc_item/get_last', data)
  },
  /**
   * 获取上月刊例报价
   * @param data
   * @returns {Promise}
   */
  getLastPublicationQuote(data) {
    return request.post('/plc_item/get_last_quote', data)
  },
  /**
   * getPublicationInfoItems
   * @description 刊例详情及其明细
   * @param {*} data
   * @returns
   */
  getPublicationInfoItems(data) {
    return request.post('/plc/get_info_items', data)
  }, /**
   * 刊例调整列表
   * @param data
   * @returns {Promise}
   */
  getPublicationItemList(data) {
    return request.post('/plc_item/list', data)
  }, /**
   * 一个刊例调整明细
   * @param id
   * @returns {Promise}
   */
  getPublicationItemInfo(id) {
    let data = { id: id }
    return request.post('/plc_item/get_info', data)
  }, /**
   * 获取详情(通过红人ID、平台、pm_id)
   * @param data
   * @return {*}
   */
  getPublicationItemInfoByArtistPlatform(data) {
    return request.post('/plc_item/get_info_by_artist_platform', data)
  }, /**
   * 保存刊例调整
   */
  savePublicationItem(data) {
    return request.post('/plc_item/store', data)
  },

  /**
   * 简单保存刊例提报信息
   * @param id
   * @param formMap formMap {k1:v1,k2:v2, ...}
   * @returns {Promise}
   */
  sampleSavePublicationItem(id, formMap) {

    return request.post('/plc_item/sample_edit', { id, 'kv': formMap })
  }, /**
   * 保存刊例调整
   */
  saveQuoteItem(data) {
    return request.post('/plc_item/save_quote', data)
  }, /**
   * 保存-基本信息
   * @param data
   * @returns {Promise}
   */
  saveBasePublicationItem(data) {
    return request.post('/plc_item/save_base', data)
  }, /**
   * 申请修改刊例价格
   */
  applyEditPricePublicationItem(data) {
    return request.post('/plc_item/apply_edit_price', data)
  }, /**
   *
   * 获取报价配置
   * @param data
   * @returns {Promise}
   */
  getPublicationSetting(data) {
    return request.post('/plc/get_setting', data)
  }, /**
   * 红人某平台截至某月的实时数据
   * @param data
   * @returns {Promise}
   */
  getPublicationCurrentData(data) {
    return request.post('/plc/get_current_data', data)
  }, /**
   * 获取广告订单数
   * @param data
   * @returns {Promise}
   */
  getPublicationOrderTotal(data) {
    return request.post('/plc/get_order_total', data)
  },

  /**
   * 保存终价
   * @param data
   * @returns {Promise}
   */
  saveRealQuote(data) {
    return request.post('/plc_item/save_real_quote', data)
  }, /**
   * 保存-刊例提报
   * @param data
   * @returns {Promise}
   */
  savePlcItem(data) {
    return request.post('/plc_item/save_item', data)
  },

  /**
   * 获取红人粉丝信息
   * @param data
   * @returns {Promise}
   */
  getFansData(data) {
    return request.post('/plc_item/get_fans_data', data)
  }, /**data
   *  刊例筛选：下拉框数据，比如组织
   *
   * @returns {Promise}
   */
  getPublicationOption() {
    return request.get('/plc_month/option', {})
  }, /**
   * getPublicationList
   * @description 月刊例列表列表
   * @param {*} data
   * @returns
   */
  getPublicationMonthList(data) {
    return request.post('/plc_month/list', data)
  }, /**
   * 月刊详情
   * @param id
   * @returns {Promise}
   */
  getPublicationMonthDetail(id) {
    return request.post('/plc_month/detail', { id: id })
  }, /**
   * 保存月刊基本信息及各平台基本刊例信息
   * @param data
   * @returns {Promise}
   */
  savePublicationMonthInfo(data) {
    return request.post('/plc_month/store', data)
  }, /**
   * 保存月刊基本信息及各平台基本刊例信息
   * @param data
   * @returns {Promise}
   */
  savePublicationCoverInfo(data) {
    return request.post('/plc_month/cover/store', data)
  },


  /**
   * 删除月刊
   * @param id
   * @returns {Promise}
   */
  delPublicationMonthInfo(id) {
    return request.post('/plc_month/delete', { id: id })
  }, /**
   * 刊例申请改价记录
   * @param id
   * @returns {Promise}
   */
  getPlcItemApplyRecord(id) {
    return request.post('/plc_item/get_apply_records', { plc_id: id })
  }, /**
   * 处理：刊例申请改价记录
   * @param data
   * @returns {Promise}
   */
  handlePlcItemApplyRecord(data) {
    return request.post('/plc_item/handle_apply_record', data)
  }, /**
   * 通知定价
   * @returns {Promise}
   * @param id
   */
  handleRealQuoteNotify(id) {
    return request.post('/plc_item/real_quote_notify', { id: id })
  }, /**
   * 红人平台刊例报价
   * @returns {Promise}
   * @param data
   */
  getQuotationData(data) {
    return request.post('/kol/quote_list', data)
  }, getQuotationCharts(data) {
    return request.post('/kol/quote_charts', data)
  }
}

export function getPlcTpl(plcId) {
  return request.get('/plc/get_tpl', { plc_id: plcId })
}

/**
 *  保存模板的配置
 * @param tplId
 * @param setting
 * @returns {Promise}
 */
export function savePlcTpl(tplId, setting) {
  return request.post('/plc/save_tpl', { id: tplId, setting: setting })
}

/**
 * 刊例提报日志
 * @param plcId
 * @returns {Promise}
 */
export function getPlcItemLog(plcId) {
  return request.get('/plc_item/logs', { id: plcId })
}

export function getPlcExportData(id) {
  return request.get('/plc/export_data', { id: id })
}

export function syncOrgToItems(id, org_name) {
  return request.post('/plc/sync_org', { id: id, org_name: org_name })
}

export function createPublicationMonth(data) {
  return request.post('/plc_month/store', data)
}

/**
 * 追加刊例类型
 *  沿用数据：
 *    合作须知
 *    提报模板
 *    提报记录
 * @param data
 * @returns {Promise}
 */
export function appendPublication(data) {
  return request.post('/plc/add', data)
}

export function reSortPublication(ids) {
  return request.post('/plc/order', { ids: ids })
}

/**
 * 检查[红人]刊例是否已提报
 *
 * @returns {Promise}
 */
export function checkExistPublicationItem(pid, artist_id) {
  return request.post('/plc_item/check_exist', { pid: pid, artist_id: artist_id })
}

/**
 * 详情（刊例定价列表用）
 * @param id
 * @return {*}
 */
export function detailForPriceList(id) {
  return request.post('/plc_month/detail_for_price_list', { id })
}

/**
 * 平台选项（某一期刊例下指定红人已提报的“平台”）
 * @param data
 * @return {*}
 */
export function platformsTheArtist(data) {
  return request.post('/plc_month/platforms_the_artist', data)
}

/**
 * 申请中的报价
 * @param plc_id
 * @return {*}
 */
export function getApplyThePlcId(plc_id) {
  return request.post('/plc_item/get_apply_the_plc_id', { plc_id })
}

